import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    items: [
      { summaryReportId: "summary-report-2026-w33", weekStart: "2026-08-10", weekEnd: "2026-08-16", timezone: "Asia/Taipei", generatedAt: 1787040000, siteCreatedAt: "2026-05-20" },
      { summaryReportId: "summary-report-2026-w32", weekStart: "2026-08-03", weekEnd: "2026-08-09", timezone: "Asia/Taipei", generatedAt: 1786435200, siteCreatedAt: "2026-05-20" },
      { summaryReportId: "summary-report-2026-w31", weekStart: "2026-07-27", weekEnd: "2026-08-02", timezone: "Asia/Taipei", generatedAt: 1785830400, siteCreatedAt: "2026-05-20" },
    ],
  },
};

const summaryReportListSlice = createSlice({ name: "summaryReportList", initialState });

export default summaryReportListSlice.reducer;
